<nwm-menu />

<div class="content">
  <div class="main">
    <div class="row no-gutters mb-5 mt-4 pb-5">
      <div class="col-xxl-10 offset-xxl-1 pb-5">
        <a [routerLink]="currentReRg?.RergType === 'PGF' ? '/pgf-resources/pgf_news' : '/pgf-intro/pgf_news'" style="color:#333;text-decoration: none"><b>&lt; Back</b></a>
        <h1 class="mt-2 mb-4">News in the Community</h1>
        <news topic="PGF" />
      </div>
    </div>
  </div>
</div>